import Task from "../task"
import Project from "../../project/project"

export default class FinderTaskModel extends Task {

    public _icon?       : string
    public _project?    : Project

    public subtasks?    : FinderTaskModel[]

    constructor(data:any) {
        super(data, {useProxy: false})

        this._icon      = data.icon
        this._project   = data.project ? new Project(data.project) : undefined
    }

    get icon() {
        return this._icon || gd.session.taskTypes.get(this.taskTypeId)?.icon
    }

    get project() {
        return this._project || gd.session.projects.get(this.projectId)
    }
}
